import { render, staticRenderFns } from "./MemberSuggestiveSearchBox.vue?vue&type=template&id=7371ffa8&scoped=true&"
import script from "./MemberSuggestiveSearchBox.vue?vue&type=script&lang=js&"
export * from "./MemberSuggestiveSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./MemberSuggestiveSearchBox.vue?vue&type=style&index=0&id=7371ffa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7371ffa8",
  null
  
)

export default component.exports